import PublicAppContainer from 'app_components/layouts/public'
import TutorialsModule from 'app_components/modules/TutorialsModule/TutorialsModule'
import React, { FC } from 'react'

import './TutorialsPage.scss'

const TutorialsPage: FC = () => {
  return (
    <PublicAppContainer>
      <TutorialsModule />
    </PublicAppContainer>
  )
}

export default TutorialsPage
